import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "info-label" }
const _hoisted_3 = { class: "info-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-6" }, "Profil Angajat", -1)),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "red-darken-1",
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    (_ctx.profil)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  elevation: "2",
                  rounded: "xl",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "pa-4 pb-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2",
                          color: "red-darken-1"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-account-details", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[5] || (_cache[5] = _createTextVNode(" Date angajat ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "pa-4" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campuriReadOnly, (camp) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "info-row",
                            key: camp.key
                          }, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(camp.label), 1),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.profil[camp.key] ?? '—'), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  elevation: "2",
                  rounded: "xl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "pa-4 pb-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2",
                          color: "blue-darken-1"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-pencil", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Date de contact ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "pa-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          modelValue: _ctx.editValid,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editValid) = $event)),
                          ref: "editForm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.Email,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editForm.Email) = $event)),
                              label: "Email",
                              "prepend-inner-icon": "mdi-email",
                              variant: "outlined",
                              density: "comfortable",
                              class: "mb-3",
                              rules: [_ctx.emailRule],
                              type: "email"
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.editForm.Telefon,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editForm.Telefon) = $event)),
                              label: "Telefon",
                              "prepend-inner-icon": "mdi-phone",
                              variant: "outlined",
                              density: "comfortable"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.saveMsg)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: _ctx.saveMsgType,
                              variant: "tonal",
                              class: "mt-2",
                              closable: "",
                              "onClick:close": _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveMsg = ''))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.saveMsg), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "red-darken-1",
                          loading: _ctx.saveLoading,
                          disabled: !_ctx.editValid,
                          onClick: _ctx.salveaza
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { class: "mr-1" }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-content-save", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[9] || (_cache[9] = _createTextVNode(" Salvează ", -1))
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}